import api from './api';

// Register a new user
export const register = async (userData) => {
  try {
    const response = await api.post('/auth/register', userData);
    // Store the token in localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Resend email verification
export const resendVerification = async (email) => {
  try {
    const response = await api.post('/auth/resend-verification', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Login user
export const login = async (email, password) => {
  try {
    const response = await api.post('/auth/login', { email, password });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Login with Google OAuth
export const loginWithGoogle = async (credential) => {
  try {
    const response = await api.post('/auth/google', { credential });
    // Store the token in localStorage
    if (response.data.token) {
      localStorage.setItem('token', response.data.token);
    }
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Get current user
export const getCurrentUser = async () => {
  try {
    const response = await api.get('/auth/me');
    return response.data;
  } catch (error) {
    // If there's an error (like token expired), remove the token
    if (error.response?.status === 401) {
      logout();
    }
    throw error.response?.data || error.message;
  }
};

// Logout user
export const logout = () => {
  // Remove token from localStorage
  localStorage.removeItem('token');
  // Clear any other user-related data
  // ...
  // No backend logout route is required for JWT-based auth; removing the token locally is sufficient
};

// Update user details
export const updateDetails = async (userData) => {
  try {
    const response = await api.put('/auth/updatedetails', userData);
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Update password
export const updatePassword = async (currentPassword, newPassword) => {
  try {
    const response = await api.put('/auth/updatepassword', {
      currentPassword,
      newPassword,
    });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Forgot password
export const forgotPassword = async (email) => {
  try {
    const response = await api.post('/auth/forgotpassword', { email });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Reset password
export const resetPassword = async (token, password) => {
  try {
    const response = await api.put(`/auth/resetpassword/${token}`, { password });
    return response.data;
  } catch (error) {
    throw error.response?.data || error.message;
  }
};

// Check if user is authenticated
export const isAuthenticated = () => {
  return !!(sessionStorage.getItem('token') || localStorage.getItem('token'));
};

// Get auth token
export const getToken = () => {
  return localStorage.getItem('token');
};
